module.exports = __webpack_public_path__ + "img/中国民生银行.3648e23a.png";